/* -----------------Child components--------------- */
import { CustomAppbar } from "components/index";

import { appBarMeta } from "@constants/appbar";
import { pageViewTypes } from "@constants/tracking";
/* -----------------Features--------------- */
import { ProgressContainer } from "@features/dashboard";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import { useDevice } from "@hooks/useDevice";
import DocumentTitle from "components/DocumentTitle";
import { useTranslation } from "react-i18next";

const ProgressRoute = () => {
	const { t } = useTranslation();
	const { isMobile } = useDevice();

	useAnalytics({
		type: pageViewTypes.progress,
	});

	const finalHeaderSubtitle = isMobile
		? ""
		: t(appBarMeta.progress.description);
	return (
		<>
			<CustomAppbar
				showHambugerMenu
				showCommandBar={isWeb}
				options={{
					headerTitle: t(appBarMeta.progress.title),
					subtitle: finalHeaderSubtitle,
				}}
			/>
			<DocumentTitle title={t(appBarMeta.progress.title)} />
			<ProgressContainer />
		</>
	);
};

export default ProgressRoute;
